import { useEffect } from 'react';
import { useTierIdentities } from '@/api/community-hooks';
import { applyTierIdentityOverrides } from '@/lib/tier-config';

/**
 * Headless loader for data-driven tier identity.
 *
 * Pulls each tier's DB badge + accent (`community_tiers.icon_url` /
 * `.accent_color`) once and pushes it into the tier-config override store, so a
 * super_admin's edits in /admin/tier-settings take effect app-wide without a
 * deploy. Renders nothing.
 *
 * Best-effort by design: the DB is seeded to the same defaults the frontend
 * ships (Hermes migration 463), so if this query is slow, empty (anon), or
 * fails, every surface still shows the correct badge — there is no first-paint
 * flash and no hard dependency on the fetch.
 */
export function TierIdentityLoader() {
  const { data } = useTierIdentities();

  useEffect(() => {
    if (data) applyTierIdentityOverrides(data);
  }, [data]);

  return null;
}
